import { ReactComponent as ShoppingCartIcon } from "./cart.svg";

import Icon from "../Icon";

export default ShoppingCartIcon as any as Icon;
